export default __webpack_public_path__ + "static/media/screenshot_app_results_purple.3ea7fa94.png";